import { NumericInputBase } from './NumericInputBase'
import type { FieldInputProps } from '../types'

/** EDIT-mode dla FieldType=CURRENCY. PL format, 2 miejsca po przecinku, sufiks "zł". */
export function CurrencyInput({ field, value, onChange, disabled }: FieldInputProps) {
  return (
    <NumericInputBase
      id={`field-${field.fieldCode}`}
      value={value}
      onChange={onChange}
      disabled={disabled}
      decimals={2}
      suffix="zł"
    />
  )
}
